
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17.83 14.555"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.278 13.463a.3.3 0 01-.023-.154c.008-.041-.019-.076-.08-.1s-.091-.047-.091-.062-.044-.027-.131-.034l-.131-.011H3.275a1.751 1.751 0 01-1.285-.537 1.752 1.752 0 01-.535-1.28v-8.01a1.752 1.752 0 01.535-1.29 1.752 1.752 0 011.285-.535h3.639a.343.343 0 00.233-.074.378.378 0 00.114-.222 1.913 1.913 0 00.034-.267 2.829 2.829 0 00-.006-.3Q7.278.405 7.278.36a.369.369 0 00-.364-.364H3.275A3.155 3.155 0 00.961.957 3.154 3.154 0 000 3.275v8.01a3.154 3.154 0 00.961 2.314 3.154 3.154 0 002.314.961h3.639a.345.345 0 00.233-.074.378.378 0 00.114-.222 1.917 1.917 0 00.034-.267 2.827 2.827 0 00-.006-.3q-.012-.188-.011-.234z"}}),_c('path',{attrs:{"d":"M17.613 6.766L11.427.58a.728.728 0 00-1.24.512v3.275H5.093a.738.738 0 00-.728.728v4.367a.738.738 0 00.728.728h5.094v3.275a.724.724 0 001.24.512l6.186-6.186a.714.714 0 000-1.024z"}})])
          )
        }
      }
    